// Libs
import React from "react";
import { Card } from "antd";

// Components
import DashboardControlPanelDevice from "components/contents/dashboard/devices";

// Styles
import s from "./index.module.scss";

function DashboardDevices() {
  return (
    <>
      <Card className={s.container}>
        <section className={s.section}>
          <DashboardControlPanelDevice />
        </section>
      </Card>
    </>
  );
}

export default DashboardDevices;
